import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar  } from '@angular/material';
import { NgForm } from '@angular/forms';
import { DoctorService } from '../../services/doctor.service';
import { CommonService } from '../../services/common.service';
@Component({
  selector: 'app-sendnotification',
  templateUrl: './sendnotification.component.html',
  styleUrls: ['./sendnotification.component.css']
})
export class SendnotificationComponent implements OnInit {
  userid: any;
  status= 'Requested';
  category: any;
  message: any;
  email= 'no';
  sms = 'no';
  pushmessage = 'no';
  msg: any;
  action: any;
  ownuid: any;
  loading: any;
  constructor(public DialogRef: MatDialogRef<SendnotificationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private snackbar: MatSnackBar, 
  private doctorService:DoctorService, private commonService:CommonService ) {
      this.userid = data.userid;
      if(this.userid != 'all') {
        this.category = 'Individual';
      }
      else{
        this.category = 'Bulk';
        this.userid = 0;
      }
      const udata = this.commonService.getUserDataLocally();
     this.ownuid = udata.uid;
     }

  ngOnInit() {
  }
  checkEmail(e, data) {
    if (e.target.checked) {
      this.email = 'yes'
    }
    if ( !e.target.checked) {
      this.email = 'no'
    }
  }
  checkSms(e, data) {
    if (e.target.checked) {
      this.sms = 'yes'
    }
    if ( !e.target.checked) {
      this.sms = 'no'
    }
  }
  checkPushSms(e, data) {
    if (e.target.checked) {
      this.pushmessage = 'yes'
    }
    if ( !e.target.checked) {
      this.pushmessage = 'no'
    }
  }
  sendrequest(){
    if(this.email=='no' && this.sms == 'no' && this.pushmessage == 'no') {
      this.msg= "Please select any of this type";
      this.openSnackBar();
    }
    else if(this.message == undefined) {
      this.msg = 'Please enter Message what you want to send';
      this.openSnackBar();
    }
    else{
     this.proceedrequest();
    }
    
  }
  openSnackBar() {
    this.snackbar.open(this.msg , this.action, {
      duration: 4000,
    });
  }
  proceedrequest(){
    this.loading = true;
    this.doctorService.sendNotificationRequestToUser(this.ownuid, this.userid, this.category,this.message,
    this.email,this.sms,this.pushmessage,this.status)
    .subscribe(
      (x)=>{
        this.loading = false;
        this.msg = "Request Queued Successfully";
        this.openSnackBar();
        this.Goback();
      });
  }
  Goback(){
    this.DialogRef.close();
  }
}
